<template>
  <modal
    :show.sync="isDisplayed"
    header-classes="justify-content-center"
    footer-classes="px-4 py-3"
    :centered="true"
    class="modal-default"
  >
    <!-- Header Slot -->
    <h4
      slot="header"
      class="title title-up"
    >
      {{ headerCopy }}
    </h4>

    <div class="mb-3">
      <label
        for="name"
        class="form-label"
      >
        Name
      </label>
      <input
        id="name"
        v-model="name"
        type="text"
        class="form-control"
        placeholder="Name"
      >
    </div>

    <!-- Footer Slot -->
    <template slot="footer">
      <base-button
        size="sm"
        :loading="loading"
        class="ml-auto"
        @click="submit"
      >
        Submit
      </base-button>
    </template>
  </modal>
</template>

<script>
import {Modal} from "src/components";
import {mapMutations} from "vuex";
import {createCodeWordGroup, updateCodeWordGroup} from "../../../api";
import {isDefined} from "../../../api/helpers";

export default {
  name: "group-form",
  components: {
    Modal,
  },
  data() {
    return {
      loading: false,
      isDisplayed: false,
      groupId: null,
      name: "",
      headerDisplay: null,
    };
  },
  computed: {
    headerCopy() {
      return this.groupId !== null ? `Update ${this.headerDisplay}` : "Add New Group";
    },
  },
  mounted() {
  },
  methods: {
    ...mapMutations("data", ["putCodeWordGroup"]),
    display(group) {
      if (group) {
        this.groupId = group.id;
        this.name = group.name;
        this.headerDisplay = group.name;
      }
      this.isDisplayed = true;
    },
    reset() {
      this.isDisplayed = false;
      this.loading = false;
      this.groupId = null;
      this.name = "";
      this.headerDisplay = null;
      this.$emit("close");
    },
    submit() {
      if (this.loading) return;
      this.loading = true;
      if (isDefined(this.groupId)) {
        updateCodeWordGroup(
          this.groupId,
          this.name
        ).then((group) => {
          this.loading = false;
          this.putCodeWordGroup(group);
          this.$emit("updated", group);
          this.$notifySuccess(`Updated: ${group.name}`);
          this.reset();
        }).catch((ex) => {
          this.loading = false;
          this.$notifyError("Failed to update entry", ex);
        });
      } else {
        createCodeWordGroup(
          this.name
        ).then((group) => {
          this.loading = false;
          this.putCodeWordGroup(group);
          this.$emit("created", group);
          this.$notifySuccess(`Created new entry: ${group.name}`);
          this.reset();
        }).catch((ex) => {
          this.loading = false;
          this.$notifyError("Failed to create new entry", ex);
        });
      }
    },
  },
};
</script>
